import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { align: "center" }
const _hoisted_2 = {
  align: "center",
  size: "small"
}

import { reactive, ref } from "vue";
import { ElMessage, FormInstance } from "element-plus";
import {
  userregister,
} from "../request/userlist";

export default /*@__PURE__*/_defineComponent({
  __name: 'register',
  props: {
  filename: String,
  fileurl: String,
  header: String,
},
  emits: ["clickChild"],
  setup(__props, { emit: __emit }) {

const showwww = ref(false)
const showw = ref(false)
const showww = () => {
  showw.value = true

}
const registerFormRef = ref<FormInstance>();
const registerForm = reactive({
  userid: "",
  userpw: "",
  name: "",
  checkuserpw: "",
  email: "",
});
const validatePass = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("Please input the password"));
  } else {
    if (registerForm.checkuserpw !== "") {
      if (!registerFormRef.value) return;
      registerFormRef.value.validateField("checkuserpw", () => null);
    }
    callback();
  }
};
const validatePass2 = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("Please input the password again"));
  } else if (value !== registerForm.userpw) {
    callback(new Error("Two inputs don't match!"));
  } else {
    callback();
  }
};
const rules1 = {
  userpw: [{ validator: validatePass2, trigger: "blur" }],
  checkuserpw: [{ validator: validatePass2, trigger: "blur" }],
  userid: [{ validator: validatePass, trigger: "blur" }],
};
const submitregister = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  registerForm.name = registerForm.userid;
  formEl.validate((valid) => {
    if (valid) {
      userregister(registerForm)
        .then((res) => {
          if (res.data.code == 501) {
            ElMessage(res.data.msg);
          } else {
            ElMessage(res.data.msg);
            clickChild(1);
          }
        })

        .catch((err) => { });
    } else {
    }
  });
};
const resetForm = () => {
  registerForm.userid = "";
  registerForm.name = "";
  registerForm.checkuserpw = "";
  registerForm.userpw = "";
};
const props = __props;
const emit = __emit;
const clickChild = (type: any) => {
  let param = {
    typeid: type,
  };
  //传递给父组件
  emit("clickChild", param);
};

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[13] || (_cache[13] = _createElementVNode("h1", null, "注 册", -1)),
      _createVNode(_component_el_divider),
      _createVNode(_component_el_form, {
        ref_key: "registerFormRef",
        ref: registerFormRef,
        model: registerForm,
        "status-icon": "",
        rules: rules1,
        "label-width": "80px",
        class: "demo-ruleForm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "账号:",
            prop: "userid"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: registerForm.userid,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((registerForm.userid) = $event)),
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "邮箱:",
            prop: "email",
            placeholder: "此邮箱用于重置密码"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: registerForm.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((registerForm.email) = $event)),
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "密码:",
            prop: "userpw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: registerForm.userpw,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registerForm.userpw) = $event)),
                type: "password",
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "确认密码:",
            prop: "checkuserpw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: registerForm.checkuserpw,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((registerForm.checkuserpw) = $event)),
                type: "password",
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: showwww.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showwww).value = $event))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", { onClick: showww }, " 我已阅读并接受网站《用户协议》 ")
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              (showwww.value)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (submitregister(registerFormRef.value)))
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("注册", -1)
                    ]))]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    disabled: "",
                    type: "primary",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (submitregister(registerFormRef.value)))
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("注册", -1)
                    ]))]),
                    _: 1
                  })),
              _createVNode(_component_el_button, {
                class: "register_btn",
                onClick: _cache[7] || (_cache[7] = ($event: any) => {clickChild(0);})
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("退出", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: showw.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showw).value = $event)),
      "destroy-on-close": "",
      size: "small",
      width: "60%",
      "show-close": false,
      top: "5vh"
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (showw.value = false)),
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("退出", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("hr", { style: {"margin":"5px"} }, null, -1)),
        _cache[16] || (_cache[16] = _createElementVNode("div", {
          align: "center",
          style: {"width":"100%","font-size":"22px","background-color":"aquamarine","color":"brown","height":"35px","align-items":"center"}
        }, " 用  户  协  议", -1)),
        _cache[17] || (_cache[17] = _createElementVNode("p", {
          align: "left",
          style: {"width":"100%","font-size":"14px"}
        }, [
          _createTextVNode(" 1、当您在锁定健康网站注册用户过程中选择”我已阅读并接受网站《用户协-议》”即表示用户完全接受本协议的全部条款"),
          _createElementVNode("br"),
          _createTextVNode(" 2、用户使用锁定健康网站的服务，以及参加锁定健康网站组织的活动时，即视为您同意锁定健康网站将收集您的个人信息，并保存记录。锁定健康网站收集的个人信息包括但不限于：头像、性别、生日、身份证号、城市、手机电话、邮箱、运动与健康数据等。您主动提供的信息越多、越准确， "),
          _createElementVNode("br"),
          _createTextVNode(" 3、您提供的个人信息及运动与健康数据将仅在本网站内部或您自愿加入的网站其它机构间使用和共享，使用您的个人信息只是为了更好地了解您的需要并为您提供更好的服务或执行事务，同时本网站可能会使用您的个人信息与您联系以便向您提供服务。我们就能够更好地为您提供有关服务。 "),
          _createElementVNode("br"),
          _createTextVNode(" 4、尊重并保护用户的隐私权，在任何情况下，我们都不会将您的信息出售或泄露给任何第三方（法律另有规定的除外）。我们通过网站及其他途径所得到的所有的访问者信息仅被用来处理您的需求。 "),
          _createElementVNode("br"),
          _createTextVNode(" 5、在注册锁定健康网站账号时用户应承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，且保证在注册及使用锁定健康网站账号时，不得有以下情形： "),
          _createElementVNode("br"),
          _createTextVNode("  （1）煽动抗拒、破坏宪法和法律、行政法规实施的； "),
          _createElementVNode("br"),
          _createTextVNode(" （2）煽动颠覆国家政权，推翻社会主义制度的； "),
          _createElementVNode("br"),
          _createTextVNode("  （3）煽动分裂国家、破坏国家统一的； "),
          _createElementVNode("br"),
          _createTextVNode("  （4）煽动民族仇恨、民族歧视，破坏民族团结的； "),
          _createElementVNode("br"),
          _createTextVNode("  （5）捏造或者歪曲事实，散布谣言，扰乱社会秩序的； "),
          _createElementVNode("br"),
          _createTextVNode("  （6）宣扬封建迷信、淫秽、色情、暴力、恐怖、教唆犯罪的； "),
          _createElementVNode("br"),
          _createTextVNode("  （7）公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的 "),
          _createElementVNode("br"),
          _createTextVNode("  （8）损害国家机关信誉的； "),
          _createElementVNode("br"),
          _createTextVNode("  （9）其他违反宪法和法律行政法规的； "),
          _createElementVNode("br"),
          _createTextVNode("  （10）发布黄色、反动文章。 "),
          _createElementVNode("br"),
          _createTextVNode(" 6、您应保证提供的注册资料真实、准确、完整、合法有效，您的注册资料如有变动，应及时更新。因您提供的注册资料不符合本条款约定而引起的一切责任及后果（包括但不限于不予注册、账号停用或注销等），将由您自行承担，且锁定健康网站保留终止您使用锁定健康网站各项服务的权利。 "),
          _createElementVNode("br"),
          _createTextVNode(" 7、用户以虚假信息骗取账号名称注册，或其账号、头像等注册信息存在违法和不良信息的，锁定健康网站网有权采取通知限期改正、暂停使用、注销登记等措施。 "),
          _createElementVNode("br"),
          _createTextVNode(" 8、对冒用、关联机构或社会名人注册账号名称的用户，锁定健康网站网有权注销其账号，并向互联网信息内容主管部门报告。 "),
          _createElementVNode("br"),
          _createTextVNode(" 9、您的锁定健康网站账号仅限于您自己使用，严禁将您的锁定健康网站账号允许第三人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。 "),
          _createElementVNode("br"),
          _createTextVNode(" 10、依据相关法律法规的规定，按照“后台实名、前台自愿”的原则，锁定健康网站有权对注册用户进行基于移动电话号码的真实身份信息认证。对于拒绝进行真实身份信息认证的用户，锁定健康网站保留拒绝此用户使用锁定健康网站相关服务的权利，并有权对用户进行包括但不限于限制服务使用、关闭账号等的处理。 ")
        ], -1))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})